import useUser from '../../../Hooks/UserContext';
const Show = (props) => {
  const user = useUser();

  const { to } = props;
  let show = false;
  if (user) {
    if (typeof to == 'string') {
      show = user.tipo.includes(to);
    }
    if (typeof to == 'function') {
      show = to(user.tipo);
    }
    if (Array.isArray(to)) {
      show = to.map((p) => user.tipo.includes(p)).reduce((a, b) => a || b)
    }
    if (!to) {
      show = true
    }
    if (typeof to == 'boolean') {
      show = to;
    }
  }

  return (show ? props.children : null)
}
export default Show